import { useEffect } from "react";
import { useGoogleReCaptcha } from "./useGoogleReCaptcha";
export const useGoogleReCaptchaVisibleToggle = () => {
  const {
    setVisibility
  } = useGoogleReCaptcha();
  useEffect(() => {
    setVisibility("visible");
    return function hideRecaptchaBadge() {
      setVisibility("hidden");
    };
  });
};